import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from '@app/core/services/i18n.service';
import { DatePipe } from "@angular/common";
import { DashboardService } from "@app/features/dashboard/dashboard.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ActivatedRoute, Router } from "@angular/router";
import { NavigationService } from '@app/shared/services/navigation-service.service';
import { AuthService } from '@app/core/services/auth.service';
import { FeatureFlagService } from '@app/shared/services/feature-flag.service';
import { RedeemModalComponent } from '@shared/redeem-modal/redeem-modal.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, OnDestroy {
  public currentDate: string | null | undefined;
  public data: any;
  @ViewChild('redeemModal') redeemModal!: RedeemModalComponent;
  public redemptionPointsCount: any;
  public fromCreateStore: any;
  private langSub?: Subscription;

  constructor(
    public spinner: NgxSpinnerService,
    public router: Router,
    private dashboardService: DashboardService,
    public navigation: NavigationService,
    private authService: AuthService,
    private route: ActivatedRoute,
    public featureFlagService: FeatureFlagService,
    private translate: TranslateService,
    private i18n: I18nService
  ) {
    this.route.params.subscribe(params => {
      const fromCreateStore = params['fromCreateStore'];
      if (fromCreateStore){
        this.preventBackwardNavigation();
      }
    });
  }

  preventBackwardNavigation() {
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener('popstate', () => {
      window.history.pushState(null, document.title, window.location.href);
    });
  }

  ngOnInit(): void {
    this.spinner.show();
    this.setCurrentDate();
    this.langSub = this.translate.onLangChange.subscribe(() => this.setCurrentDate());
    this.getData();
  }

  ngOnDestroy(): void {
    this.langSub?.unsubscribe();
  }

  private setCurrentDate(): void {
    // Locale-aware so the header reads naturally in Arabic as well as English.
    this.currentDate = new DatePipe(this.i18n.getLocale() === 'ar' ? 'ar' : 'en-US')
      .transform(new Date(), 'mediumDate');
  }

  public getData() {
    this.dashboardService.getDashboardData().subscribe(res => {
      this.data = res;
      this.redemptionPointsCount = this.data?.redemptionPointsCount;
      this.spinner.hide();
    }, error => {
      console.log(error);
      this.spinner.hide();

    })
  }

  scanRedeem() {
    this.redeemModal.open();
  }

  public onRedeem(data: { code: string; amount: number }) {
    this.dashboardService.redeem(data.code, data.amount).subscribe(res => {
      this.redeemModal.handleRedeemSuccess();
    },
      error => {
        this.redeemModal.handleRedeemError();
        console.log(error);
      })
  }
  navigateToRedemptionPoints() {
    this.router.navigate(['/redemptionpoints']);
  }
  public onCreateVoucher() {
    this.router.navigate(['vouchers/-1'])
  }
}
